<h3 class="title configurator-title">{{ 'fence.environment.title' | translate }}</h3>
<div class="config-container shadow">
  <h4 class="title configurator-subtitle">{{ 'fence.environment.your-location' | translate }}</h4>
  <div class="location-container">
    <div
      class="location-card"
      [ngClass]="{ active: isLocationSelected(location.id) }"
      *ngFor="let location of locations"
      (click)="selectLocation(location)">
      <img [src]="baseImgURL + location.icon.path" alt="location-img" class="location-img" />
      <p class="location-title" *ngIf="currentLang === 'fr'">{{ location.nameFr }}</p>
      <p class="location-title" *ngIf="currentLang === 'en'">{{ location.nameEn }}</p>
    </div>
    <ng-casto-loader *ngIf="locations === undefined"></ng-casto-loader>
  </div>

  <ng-container *ngFor="let location of locations">
    <div class="location-info" *ngIf="isLocationSelected(location.id) && location.toolTip">
      <div class="location-info-icon">
        <svg>
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/img/icons.svg#icon-action-zoom"></use>
        </svg>
      </div>

      <div class="location-info-container">
        <h6 class="location-info-title" *ngIf="currentLang === 'fr'">
          <i
            ><strong class="more-infos">{{ 'fence.environment.more-info' | translate }}</strong> -
            <strong>{{ location.toolTip.titleFr }}</strong></i
          >
        </h6>
        <h6 class="location-info-title" *ngIf="currentLang === 'en'">
          <i
            ><strong class="more-infos">{{ 'fence.environment.more-info' | translate }}</strong> -
            <strong>{{ location.toolTip.titleEn }}</strong></i
          >
        </h6>
        <p class="terrain-info-description" *ngIf="currentLang === 'fr'">{{ location.toolTip.descriptionFr }}</p>
        <p class="terrain-info-description" *ngIf="currentLang === 'en'">{{ location.toolTip.descriptionEn }}</p>
      </div>
      <div class="location-info-image" *ngIf="location.toolTip.img != null">
        <img src="{{ location.toolTip.img }}" alt="terrain-info-img" />
      </div>
    </div>
  </ng-container>

  <div *ngIf="hasWall()">
    <h4 class="title configurator-subtitle">{{ 'fence.environment.wall' | translate }}</h4>
    <div class="form-row">
      <div class="form-label">
        <label for="wallHeight">{{ 'fence.environment.wall-height' | translate }}</label>
      </div>
      <div class="form-input">
        <div class="cm">
          <input
            type="number"
            id="wallHeight"
            autocorrect="off"
            spellcheck="false"
            (change)="selectWallHeight($event)"
            [(ngModel)]="configuration.wallHeight"
            [min]="1"
            [max]="maxWallHeight" />
        </div>
      </div>
    </div>
  </div>
</div>
